import EntityInputField from "vue-forms/components/EntityInputField";
import EntityFormField from "vue-forms/components/EntityFormField";
import service from "./TagService";

const TagInputField = {
  name: "tag-input-field",

  mixins: [EntityInputField],

  props: {
    service: {
      default: () => service
    }
  },

  methods: {
    customLabel(item) {
      return item.label;
    }
  }
};

export default {
  name: "tag-form-field",

  mixins: [EntityFormField],

  props: {
    component: {
      default: () => TagInputField
    }
  }
};
